import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../SectionsHeading";
import {
  GifImage,
} from "../../../Styles/style";
import Paragraph from "../../Paragraph";

const GridWraper = styled(Grid)`
  width: 100%;
  height: 100%;
  display: flex;
  /* flex-direction:column; */
  justify-content: center;
  align-items: center;
  padding: 100px 0 0;
`;
const ContinerWraper = styled(Container)`
  background: ${(props) => props.theme.bgPrimary};
  height: auto;
  width: 100%;
  padding: 0 !important;
`;

const AboutSection = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="about">
      <Container>
        <GridWraper container>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <GifImage mw="250px" mw599="180px" src="./Images/Crypto bros.png" />
          </Grid>
          <Grid item xs={12}>
            <SectionsHeading ta="center">About the token</SectionsHeading>
          </Grid>
          <Grid item xs={10} md={8}>
            <Paragraph>
              Hold onto your hats, folks, because we're taking you on a wild
              ride through the wackiest crypto project in town – Obama Predator!
              Get ready to witness the ultimate face-off between Donald Trump
              and Barack Obama that's so out-of-this-world, it might just be
              from another galaxy.
            </Paragraph>
            <Paragraph>
              Hold onto your hats, folks, because we're taking you on a wild
              ride through the wackiest crypto project in town – Obama Predator!
              Get ready to witness the ultimate face-off between Donald Trump
              and Barack Obama that's so out-of-this-world, it might just be
              from another galaxy.
            </Paragraph>
          </Grid>
        </GridWraper>
      </Container>
    </ContinerWraper>
  );
};

export default AboutSection;
